import { lazy } from "react";
import { authRoles } from "./utils/authenticationRoles";
import Layout from "./components/dashboard/layout/Layout";
import Loadable from "./components/dashboard/Loadable";
import NotFound from "./pages/not-found/NotFound";
import AuthGuard from "./guards/AuthGuard";

const ThirtyFiveYearsFMILandingPage = Loadable(lazy(() => import("./pages/conferences/thirty-five-years-fmi/ThirtyFiveYearsFMILandingPage")));
const NDMIConferenceLandingPage = Loadable(lazy(() => import("./pages/conferences/ndmi/NDMILandingPage")));
const ConferenceApplication = Loadable(lazy(() => import("./pages/conference-application/ConferenceApplication")));
const Login = Loadable(lazy(() => import("./pages/authentication/login/Login")));
const ConferenceApplicationsManagement = Loadable(lazy(() => import("./pages/dashboard/conference-applications/ConferenceApplicationsManagement")));
const SpecialSessionsManagement = Loadable(lazy(() => import("./pages/dashboard/special-sessions/SpecialSessionsManagement")));

const authenticationRoutesObjectData: any[] = [
  {
    path: "/authentication/login",
    element: <Login />
  },
  {
    path: "*",
    element: <NotFound />
  }
];

const routesObjectData: any[] = [
  {
    path: "/",
    element: <ThirtyFiveYearsFMILandingPage />,
  },
  {
    path: "/conference-application",
    element: <ConferenceApplication
      applicationWithReportOrWithSpecialSessionDeadlineString="2025-11-20"
      conferenceApplicationFinalDeadlineString="2025-11-24"
      scientificFieldOptionsKeys={[
        'conferenceApplication.scientificFields.thirtyFiveYearsFMI.mathematicalAndAppliedSciences',
        'conferenceApplication.scientificFields.thirtyFiveYearsFMI.informationAndCommunicationTechnologies',
        'conferenceApplication.scientificFields.thirtyFiveYearsFMI.educationInMathematicsAndInformatics'
      ]}
      conferenceYearFilter={2025}
    />
  },
  {
    path: "/ndmi",
    element: <NDMIConferenceLandingPage />
  },
  {
    path: "/ndmi/conference-application",
    element: <ConferenceApplication
      applicationWithReportOrWithSpecialSessionDeadlineString="2024-11-11"
      conferenceApplicationFinalDeadlineString="2024-11-16"
      scientificFieldOptionsKeys={[
        'conferenceApplication.scientificFields.ndmi.mathematicalAnalysisGeometryAndApplications',
        'conferenceApplication.scientificFields.ndmi.discreteStructures',
        'conferenceApplication.scientificFields.ndmi.computerScience',
        'conferenceApplication.scientificFields.ndmi.educationInMathematicsAndInformatics'
      ]}
      conferenceYearFilter={2024}
    />
  },
  {
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [
      {
        path: "dashboard/default",
        element: <ConferenceApplicationsManagement />,
        auth: authRoles.admin
      },
      {
        path: "dashboard/special-sessions",
        element: <SpecialSessionsManagement />,
        auth: authRoles.admin
      }
    ],
  },
  ...authenticationRoutesObjectData
];

export default routesObjectData;